import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import {
    Typography,
} from "@mui/material";

import { NewTabInterface } from '../../../Models/Common/CustomViewsInterfaces';

const CustomLink: any = styled(Link)<{ }>`
    text-decoration: none;
`;

export default function NewTab(props: NewTabInterface) {
    const navigate = useNavigate();

    return <CustomLink className='pltlinkBtn'
        // href={props.linkUrl}
        to={props.linkUrl} >
            <Typography className={"textLink " + (props?.linkClassName ?? "")} sx={{cursor: "pointer"}} variant="caption" color="info" gutterBottom >{props.linkTitle}</Typography>
        </CustomLink>
}